<template>
  <path pid="0" d="M21 20h-7.18A3 3 0 0111 17V7.41l3.29 3.3a1 1 0 001.42-1.42l-5-5-.11-.09h-.25L10.2 4H9.48l-.08.07-5 5a1 1 0 000 1.42l.1.08a1 1 0 001.32-.08L9 7.41V17a5 5 0 005 5h7a1 1 0 000-2zM13.17 2.84l.09.08-.08-.07-.01-.01zM12.47 2.63z"/>
</template>
